import React, { Component } from "react";

class Accordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  toggleAccordion = () => {
    this.setState(() => ({
      open: !this.state.open,
    }));
  };

  render() {
    const { items, renderComponent, title, className = "" } = this.props;

    return (
      <div className={className}>
        <button onClick={() => this.toggleAccordion()}>
          {title || "Toggle"}
        </button>
        {this.state.open && items && items.length > 0 && (
          <div>
            {items.map((item, index) => (
              <div key={index}>
                {renderComponent ? renderComponent(item, index) : item}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default Accordion;
